import { RouterProvider } from "react-router-dom";
import { AuthProvider } from "@/features/auth/context/AuthContext";
import { NotificationProvider } from "@/features/notifications/context/NotificationContext";
import { StreamChatProvider } from "@/features/chat/context/StreamChatContext";
import { ActiveCallProvider } from "@/features/call/context/ActiveCallContext";
import { ActiveCallOverlay } from "@/features/call/components/ActiveCallOverlay";
import { router } from "@/routes";
import "@/i18n";

function App() {
  return (
    <AuthProvider>
      <StreamChatProvider>
        <ActiveCallProvider>
          <NotificationProvider>
            <RouterProvider router={router} />
          </NotificationProvider>
          {/* Persistent call overlay — lives outside the router so navigation
              never unmounts it. Renders nothing when no call is active. */}
          <ActiveCallOverlay />
        </ActiveCallProvider>
      </StreamChatProvider>
    </AuthProvider>
  );
}

export default App;
